// @flow
import LocalizedStrings from 'react-localization'
import _en from './en'
import _fr from './fr'
import _cn from './cn'

var I18n = new LocalizedStrings({
  en: _en,
  fr: _fr,
  cn: _cn
})
const lang = localStorage.getItem('lang')
if (lang) {
  I18n.setLanguage(lang)
}

export default I18n
